import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import AuthCallback from "@/pages/AuthCallback";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardPage from "@/pages/DashboardPage";
import TrainingSessionPage from "@/pages/TrainingSessionPage";
import SessionAnalysisPage from "@/pages/SessionAnalysisPage";
import KnowledgePage from "@/pages/KnowledgePage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ExamModePage from "@/pages/ExamModePage";
import StoryPage from "@/pages/StoryPage";
import ReadinessPage from "@/pages/ReadinessPage";
import ExpertDashboardPage from "@/pages/ExpertDashboardPage";
import CaseExamplesPage from "@/pages/CaseExamplesPage";
import B2BLandingPage from "@/pages/B2BLandingPage";
import DemoPage from "@/pages/DemoPage";
import DocumentsPage from "@/pages/DocumentsPage";
import SEOArticlePage from "@/pages/SEOArticlePage";
import ConversationModePage from "@/pages/ConversationModePage";
import LearningPathPage from "@/pages/LearningPathPage";
import FragetechnikPage from "@/pages/FragetechnikPage";
import AkteUploadPage from "@/pages/AkteUploadPage";
import ImpressumPage from "@/pages/ImpressumPage";
import AGBPage from "@/pages/AGBPage";
import KontaktPage from "@/pages/KontaktPage";
import { CookieBanner } from "@/components/CookieBanner";
import { BetaFeedbackWidget } from "@/components/BetaFeedbackWidget";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check for OAuth callback synchronously - before ProtectedRoute runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/b2b" element={<B2BLandingPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/wissen" element={<SEOArticlePage />} />
      <Route path="/wissen/:slug" element={<SEOArticlePage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="/agb" element={<AGBPage />} />
      <Route path="/kontakt" element={<KontaktPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
      <Route path="/lernpfad" element={<ProtectedRoute><Layout><LearningPathPage /></Layout></ProtectedRoute>} />
      <Route path="/training/new" element={<ProtectedRoute><Layout><TrainingSessionPage /></Layout></ProtectedRoute>} />
      <Route path="/training/:sessionId" element={<ProtectedRoute><Layout><TrainingSessionPage /></Layout></ProtectedRoute>} />
      <Route path="/conversation" element={<ProtectedRoute><Layout><ConversationModePage /></Layout></ProtectedRoute>} />
      <Route path="/conversation/:sessionId" element={<ProtectedRoute><Layout><ConversationModePage /></Layout></ProtectedRoute>} />
      <Route path="/analysis/:sessionId" element={<ProtectedRoute><Layout><SessionAnalysisPage /></Layout></ProtectedRoute>} />
      <Route path="/knowledge" element={<ProtectedRoute><Layout><KnowledgePage /></Layout></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Layout><AdminPage /></Layout></ProtectedRoute>} />
      <Route path="/exam" element={<ProtectedRoute><Layout><ExamModePage /></Layout></ProtectedRoute>} />
      <Route path="/story" element={<ProtectedRoute><Layout><StoryPage /></Layout></ProtectedRoute>} />
      <Route path="/readiness" element={<ProtectedRoute><Layout><ReadinessPage /></Layout></ProtectedRoute>} />
      <Route path="/expert" element={<ProtectedRoute><Layout><ExpertDashboardPage /></Layout></ProtectedRoute>} />
      <Route path="/examples" element={<ProtectedRoute><Layout><CaseExamplesPage /></Layout></ProtectedRoute>} />
      <Route path="/documents" element={<ProtectedRoute><Layout><DocumentsPage /></Layout></ProtectedRoute>} />
      <Route path="/fragetechnik" element={<ProtectedRoute><Layout><FragetechnikPage /></Layout></ProtectedRoute>} />
      <Route path="/akte" element={<ProtectedRoute><Layout><AkteUploadPage /></Layout></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
          <CookieBanner />
          <BetaFeedbackWidget />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
